import { useEffect, useState } from 'react';

import { personalizedReadingHubSubject } from '@utils/blueconic/constants';
import { BlueconicPersonalizedReadingHubEvent } from '@utils/blueconic/eventsInterfaces';

export interface ReadingStatProps {
  articlesRead: number;
  favoriteAuthors: string[];
  minutesRead: number;
  mostReadNewsletter: string;
  mostReadNewsletters: string[];
  mostReadTopic: string;
  mostReadTopics: string[];
  readingTime: number;
  recommendedArticles: string[];
  recommendedAuthors: string[];
  recommendedNewsletters: string[];
  trendingTopics: string[];
  userId: string;
}

const useBlueConicPersonalizedReadingHub = (): ReadingStatProps => {
  const [readingStats, setReadingStats] = useState<ReadingStatProps>({
    articlesRead: 0,
    favoriteAuthors: [],
    minutesRead: 0,
    mostReadNewsletter: '',
    mostReadNewsletters: [],
    mostReadTopic: '',
    mostReadTopics: [],
    readingTime: 0,
    recommendedArticles: [],
    recommendedAuthors: [],
    recommendedNewsletters: [],
    trendingTopics: [],
    userId: '',
  });

  useEffect(() => {
    const handleBlueconicEvent = (data: BlueconicPersonalizedReadingHubEvent) => {
      const {
        data: {
          articlesRead,
          favoriteAuthors,
          minutesRead,
          mostReadNewsletter,
          mostReadNewsletters,
          mostReadTopic,
          mostReadTopics,
          readingTime,
          recommendedArticles,
          recommendedAuthors,
          recommendedNewsletters,
          trendingTopics,
          userId,
        },
      } = data;

      setReadingStats({
        articlesRead,
        favoriteAuthors,
        minutesRead,
        mostReadNewsletter,
        mostReadNewsletters,
        mostReadTopic,
        mostReadTopics,
        readingTime,
        recommendedArticles,
        recommendedAuthors,
        recommendedNewsletters,
        trendingTopics,
        userId,
      });
    };

    const subscription = personalizedReadingHubSubject.subscribe(handleBlueconicEvent);

    return () => {
      if (subscription) {
        subscription.unsubscribe();
      }
    };
  }, []);

  return readingStats;
};

export default useBlueConicPersonalizedReadingHub;
